import React, { useCallback, useEffect, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Autocomplete, TextField } from "@mui/material";
import { ReactComponent as Config } from "../assets/images/config.svg";
import { ReactComponent as Cross } from "../assets/images/cross.svg";

import SideBar from "./SideBar";
import { useNavigate } from "react-router-dom";
import axiosClient from "../axios";
import "../assets/css/userTable.css";
import loader from "../assets/images/loader.gif";

import { dateConvert } from "../dateConverter";
import moment from "moment";
import { debounce } from "lodash";
import Pagination_2 from "./Pagination_2";
import Loader from "../helperComponent/Loader";
import loaderimg from "../assets/images/loader.gif";

const UserSurveyIpStat = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [searchBy, setSearchBy] = useState(1); // 1 userId , 2 offerId , 3 ipAttempted

  const [allProvider, setAllProvider] = useState([]);
  const [provider, setProvider] = useState({
    id: "",
    name: "",
  });

  const [filterData, setFilterData] = useState({
    page: 0,
    limit: 100,
    provider: provider.id || null,
  });


  console.log('setFilterData=======================>', filterData)

  const [date, setDate] = useState({
    start: null,
    end: null,
  });

  const getUserSeurveyIpAttempt = async () => {
    let s_date = date?.start ? dateConvert(date?.start) : null;
    let e_date = date?.end ? dateConvert(date?.end) : null;

    let body = {
      ...filterData,
      searchBy: searchBy,
      searchValue: searchValue,
      s_date: s_date,
      e_date: e_date,
    };
    console.log("body============================>", body);
    setLoading(true);
    await axiosClient
      .post(`/user/survey/ip/stat`, body)
      .then((res) => {
        console.log("res from res stats=============================>", res);
        setData(res?.data?.response);
      })
      .catch((error) => {
        console.log("error======>", error);
        alert(error?.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleChange = (e) => {
    // const { value } = e.target;
    // handleSearch(value, searchBy);
    getUserSeurveyIpAttempt();
  };

  const getPartner = () => {
    axiosClient
      .get("/partnersList")
      .then((res) => setAllProvider(res.data.response))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getUserSeurveyIpAttempt();
  }, [filterData?.page, filterData.limit]);

  useEffect(() => {
    getPartner();
  }, []);

  return (
    <>
      <SideBar handleSideBar={true} activeTab={"User Survey Ip Stat"} />
      <div className="screen">
        <div className="trans-upper-div transaction2flex">
          <h2 className="screenHeading catHead">User Survey Ip Stat</h2>

          <div className="radio-group " style={{ display: "flex", flexDirection: "row" }}>
            <label>Search By:</label>

            <label>
              <input
                type="radio"
                name="searchBy"
                value={1}
                checked={searchBy === 1}
                onChange={(e) => setSearchBy(1)}
              />
              User Id
            </label>
            <label>
              <input
                type="radio"
                name="searchBy"
                value={2}
                checked={searchBy === 2}
                onChange={(e) => setSearchBy(2)}
              />
              Offer Id
            </label>
            <label>
              <input
                type="radio"
                name="searchBy"
                value={3}
                checked={searchBy === 3}
                onChange={(e) => setSearchBy(3)}
              />
              Ip
            </label>
          </div>

          <div className="Usersearchbar autoWidth">
            <input
              type="text"
              placeholder="Search..."
              //   onChange={handleChange}
              onChange={(e) => {
                setSearchValue(e.target.value);
              }}
            />
          </div>
        </div>

        <div className="date-filter-section">
          {/* <div style={{ width: "250px" }}>
              <Autocomplete
                disablePortal
               
                value={
                  provider
                    ? provider?.name
                    : ""
                }
                onChange={(event, newValue) => {
                  if (newValue) {
                    setProvider({...provider ,  id: newValue._id , name: newValue.name, });
                  } else {
                    setProvider({
                      ...provider,
                      provider: null,
                    });
                  }
                }}
                
                options={allProvider}
               
                getOptionLabel={(option) => option["name"] || option}
                renderInput={(params) => (
                  <TextField {...params} label="Provider" />
                )}
              />
            </div> */}

          <div style={{ width: "240px" }}>
            <Autocomplete
              disablePortal
              // value={filterDataInput?.provider?.name}
              value={
                filterData?.provider ? filterData?.provider?.name : ""
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  setFilterData({
                    ...filterData,
                    provider: {
                      id: newValue._id,
                      name: newValue.name,
                    },
                  });
                } else {
                  setFilterData({
                    ...filterData,
                    provider: null,
                  });
                }
              }}
              // disabled={!selectedCheckboxes.includes(0)}
              options={allProvider}
              // getOptionLabel={option => option.name}
              getOptionLabel={(option) => option["name"] || option}
              renderInput={(params) => (
                <TextField {...params} label="Provider" />
              )}
            />
          </div>

          <div className="date-sec">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Start Date"
                value={date.start}
                onChange={(value) => setDate({ ...date, start: value })}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </div>

          <div className="date-sec">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="End Date"
                value={date.end}
                onChange={(value) => setDate({ ...date, end: value })}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </div>

          {((date?.start && date?.end) || searchValue || filterData?.provider?.id) && (
            <button
              className="date-submit-button"
              onClick={() => getUserSeurveyIpAttempt()}
            >
              Submit
            </button>
          )}
        </div>

        {data?.length > 0 ? (
          <div className="profileInfoBox table">
            <div style={{ width: "100%" }} className="container app-body">
              {loading ? (
                <>
                  {/* <Loader/> */}
                  <div className="loaderImage">
                    <img src={loaderimg} alt="loader" />
                  </div>
                </>
              ) : (
                <div className="tabel-scrol">
                  <table id="users" className="offertable">
                    <thead>
                      <tr>
                        <th>S.NO.</th>
                        <th>User Id</th>
                        <th>Offer Id</th>
                        <th>Partner Name</th>
                        <th>Ip Attempted</th>
                        <th>Visitor Id</th>
                        <th>Registered On</th>
                        <th>Clicked On</th>
                      </tr>
                    </thead>
                    {data?.map((val, key) => {
                      return (
                        <tbody key={key} id="userstbody">
                          <tr>
                            <td>
                              {filterData.page * filterData.limit + (key + 1)}
                            </td>
                            <td>{val?.userId?._id}</td>
                            <td>{val?.offerId}</td>
                            <td>{val?.partnerId?.name}</td>
                            <td>{val?.ipAttempted}</td>
                            <td>{val?.visitorId ? val?.visitorId : "null"}</td>
                            <td>{val?.userId?.registered_on
                              ? moment
                                .utc(val?.userId?.registered_on)
                                .local()
                                .format("DD/MM/YY, h:mm:ss a")
                              : "_"}</td>
                            {/* <td>{key + 1}</td> */}
                            {/* <td className='clickabuetd' onClick={() => window.open(`/users/transaction/${val?.userId}`)}>{val?.userId}</td> */}

                            <td>
                              {moment
                                .utc(val?.clicked_on)
                                .local()
                                .format("DD/MM/YY, h:mm:ss a")}
                            </td>
                          </tr>
                        </tbody>
                      );
                    })}
                  </table>
                </div>
              )}
            </div>
          </div>
        ) : (
          <h3>No Data Found</h3>
        )}
        {data?.length > 0 && (
          <Pagination_2
            filterDataInput={filterData}
            setFilterDataInput={setFilterData}
          />
        )}
      </div>
    </>
  );
};

export default UserSurveyIpStat;
